import { isObject } from "lodash-es";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ensureObject = (object?: unknown): Record<string, any> =>
  isObject(object) ? object : {};

export default ensureObject;
